import React from "react";
import Col from "react-bootstrap/lib/Col";
import { push } from "connected-react-router";
import { string, func, bool } from "prop-types";

import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import { connect, useDispatch } from "react-redux";
import I18n from "pages/_components/I18n";
import { selectors as modalselectors } from "reducers/modal";
import InfoModal from "./InfoModal";

const modalContent = (errorText, onClickOk) => (
    <MainContainer className="main-container onboarding-layout">
        <div className="above-the-fold">
            <Container className="flex-grow items-center container--layout">
                <Col className="col-12">
                    <div className="media-object media-object--state-error">
                        <figure>
                            <Image src="images/error.svg" className="svg-icon" />
                        </figure>
                        <div className="media-object--text">
                            <I18n id="" defaultValue="Disculpe!" component="h2" />
                            {errorText ? (
                                <I18n id="" defaultValue={errorText} component="h6" />
                            ) : (
                                <I18n id="" defaultValue="Su transacción fallo. Por favor reintente." component="h6" />
                            )}
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                    <Button bsStyle="primary" onClick={onClickOk} label="global.ok" defaultLabelText="OK" block />
                </Col>
            </Container>
            {/* <Container className="flex-grow items-center container--layout"></Container> */}
        </div>
    </MainContainer>
);

const ErrorPopup = ({ displayModal, error, handleClick }) => {
    const dispatch = useDispatch();

    const onClick = () => {
        if (handleClick) {
            handleClick();
        } else {
            dispatch(push("/"));
        }
    };

    return !displayModal ? null : (
        <InfoModal
            noAcceptButton
            noCancelButton
            bodyInfoText="texto"
            useScroll
            body={() => modalContent(error, onClick)}
        />
    );
};

ErrorPopup.propTypes = {
    displayModal: bool.isRequired,
    error: string,
    handleClick: func,
};

ErrorPopup.defaultProps = {
    error: "",
    handleClick: null,
};

const mapStateToProps = (state) => ({
    displayModal: modalselectors.getDisplayModal(state),
});

export default connect(mapStateToProps)(ErrorPopup);
